/**
 * Customized to add new styles for controls quantity input component
 */

import { SxProps } from '@mui/material';

export const productDetailsQuantitySX = {
	container: {
		marginRight: '10px',
	},
	quantity: (disabled?: boolean): SxProps => ({
		maxWidth: '17ch',
		minWidth: { sm: '130px', md: '98px', lg: '130px' },
		' > div': {
			height: '40px',
			...(disabled && { backgroundColor: 'grey.50' }),

			'.MuiInputBase-input': {
				height: '21px',
				...(disabled ? { color: 'grey.200' } : { color: 'grey.500' }),
				...(disabled && { backgroundColor: 'grey.50' }),

				':hover': {
					...(!disabled && { border: '1px solid' }),
					borderColor: 'grey.200',
					zIndex: '1',
				},

				':focus': {
					...(!disabled && { border: '1px solid' }),
					borderColor: 'grey.500',
					zIndex: '1',
				},
			},
		},

		'.MuiOutlinedInput-root': {
			'&:hover .MuiOutlinedInput-notchedOutline': {
				borderColor: 'grey.100',
			},
			'&.Mui-focused': {
				borderColor: 'grey.500',

				'.MuiOutlinedInput-notchedOutline': {
					borderColor: 'grey.100',
				},
			},
		},
	}),
};
